// frontend/src/data/supportArticles.js
//
// Support articles served at /p/<slug>. These URLs are inherited from the site
// that preceded the rebuild: Google still ranks 9 of them at position 1.00–3.12
// (265 impressions, 0 clicks) because the content was indexed and never
// replaced. Until now they hit the SPA fallback and rendered an empty page under
// the homepage's title — which is why a position-1 result got no clicks.
//
// Content lives in support-articles.json for the same reason as the blog: the
// prerender script is plain Node and must read it without a bundler. See the
// note at the top of seoMeta.js.

import articles from './support-articles.json'

export const supportArticles = articles

export function getSupportArticle (slug) {
  return articles.find(a => a.slug === slug)
}
